import React from 'react';
import PropTypes from 'prop-types';
import styles from './AssignmentBadge.module.css';

const AssignmentBadge = ({ count, size }) => {
  if (count === null || count === undefined) return null;

  const label =
    count === 0
      ? 'Not assigned yet'
      : `${count.toLocaleString()} ${
          count === 1 ? 'fridge' : 'fridges'
        } assigned`;

  const className = size === 'large' ? styles.badgeLarge : styles.badge;

  return <span className={className}>{label}</span>;
};

AssignmentBadge.propTypes = {
  count: PropTypes.number,
  size: PropTypes.oneOf(['default', 'large']),
};

AssignmentBadge.defaultProps = {
  count: undefined,
  size: 'default',
};

export default AssignmentBadge;
